//引入配置好的axios
import request from './base';

const server = {
  get: (url, params) =>
    request({
      url,
      method: 'get',
      params,
    }),
  post: (url, data) =>
    request({
      url,
      method: 'post',
      data,
    }),
};

const api = {
  main: {
    mainConfig: () => server.get('https://api.budaofilm.cn/config', {}),
    videosList: () => server.get('https://api.budaofilm.cn/videos', {}),
    photosList: () => server.get('https://api.budaofilm.cn/photos', {}),
    contactConfig: () => server.get('https://api.budaofilm.cn/contact', {}),
  },
};

export default api;
